import { useState } from 'react'
import { useSelector } from 'react-redux'

import { Switch } from 'antd'
import { Toolbar } from 'primereact/toolbar'

import AddNewButton from '../../../components/CustomButtons/addNewButton'
import ExportButton from '../../../components/CustomButtons/exportGreenButton'
import GlobalSearchInput from '../../../components/CustomGlobalSearchInput/globalSearchInput'
import { getMessage } from '../../../util/IntlMessages'
import { isRtv } from '../../../util/profiles'

const Header = ({
  getWalletCustomers,
  customersCount,
  exportCSV,
  exportExcelData,
  history,
  globalFilterValue,
  onGlobalFilterChange
}) => {
  const currentUser = useSelector((state) => state.auth.auth)
  const [isMyWallet, setIsMyWallet] = useState(false)

  return (
    <Toolbar
      start={
        <div>
          <h2>
            <b>Lista de Agricultores</b>
          </h2>
          {currentUser && isRtv(currentUser) && (
            <>
              <p style={{ fontSize: '12px' }}>
                {getMessage('myCustomers')}
                <Switch
                  style={{ marginLeft: 10 }}
                  checked={isMyWallet}
                  onChange={(value) => {
                    if (value) {
                      const currentUserDistricts = currentUser.districts.map(({ id }) => id)
                      getWalletCustomers({ districtId: currentUserDistricts })
                    } else {
                      getWalletCustomers()
                    }
                    setIsMyWallet(value)
                  }}
                  className="mr-2"
                  size="small"
                />
              </p>
              {isMyWallet && (
                <p style={{ fontSize: '12px' }}>{Number(customersCount).toLocaleString('pt-BR')} Eleitos</p>
              )}
            </>
          )}
        </div>
      }
      end={
        <div className="container-header-lists">
          <GlobalSearchInput value={globalFilterValue} onChange={onGlobalFilterChange} />

          <div>
            <ExportButton iconType="csv" label={getMessage('label.exportCvs')} onClick={() => exportCSV(false)} />
            <ExportButton iconType="excel" label={getMessage('label.exportXls')} onClick={exportExcelData} />
            <AddNewButton label={getMessage('createCustomer')} onClick={() => history.push(`/customer/create`)} />
          </div>
        </div>
      }
    />
  )
}

export default Header
